module.exports = __webpack_public_path__ + "static/media/totalSalesIcon.6da235ad.svg";